import { render, staticRenderFns } from "./kategori.vue?vue&type=template&id=ba990c5c&scoped=true&"
import script from "./kategori.vue?vue&type=script&lang=js&"
export * from "./kategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba990c5c",
  null
  
)

export default component.exports